import { createAsyncThunk } from '@reduxjs/toolkit';

export const ViewSellerProfile = createAsyncThunk(
    'marketplace/viewSellerProfile',
    async (opportunityId: number, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        await axios.post(
            `/api/Marketplace/MarketplaceOpportunities/${opportunityId}/ViewSellerProfile`
        );
    }
);
